import logger from '@/utils/logger';

import { NoAuthLayout } from '../../components/NoAuthLayout';
import { AuthkitCallbackPage } from '../../pages/AuthkitCallbackPage';
import { LoginPage } from '../../pages/LoginPage';
import { LogoutPage } from '../../pages/LogoutPage';
import { PrivacyPolicyPage } from '../../pages/PrivacyPolicyPage';
import { SignupPage } from '../../pages/SignupPage';
import { TermsOfUsePage } from '../../pages/TermsOfUsePage';
import { PublicRoute } from '../guards';

export const publicRoutes = {
  Component: NoAuthLayout,
  children: [
    // { index:false },
    {
      path: 'login',
      Component: () => (
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      ),
      loader: async () => {
        logger.log('[Loader] Login route');
        return null;
      },
    },
    {
      // Registered as a WorkOS redirect URI, so the path is part of the
      // vendor's configuration, not just ours — renaming it means editing
      // the environment's redirect URIs in the same change.
      //
      // Outside PublicRoute on purpose: that guard bounces an already-signed-in
      // user away, and arriving here holding a stale session is the normal
      // case when re-authenticating.
      path: 'auth/callback',
      Component: () => <AuthkitCallbackPage />,
      loader: async () => {
        logger.log('[Loader] AuthKit callback route');
        return null;
      },
    },
    {
      path: 'logout',
      Component: () => <LogoutPage />,
      loader: async () => {
        logger.log('[Loader] Logout route');
        return null;
      },
    },
    {
      path: 'signup',
      Component: () => (
        <PublicRoute>
          <SignupPage />
        </PublicRoute>
      ),
      loader: async () => {
        logger.log('[Loader] Signup route');
        return null;
      },
    },
    {
      path: 'privacy-policy',
      Component: PrivacyPolicyPage,
      loader: async () => {
        logger.log('[Loader] Privacy Policy route');
        return null;
      },
    },
    {
      path: 'terms-of-use',
      Component: TermsOfUsePage,
      loader: async () => {
        logger.log('[Loader] Terms of Use route');
        return null;
      },
    },
  ],
};
